<div style="display: flex; justify-content: space-between; flex-direction: row;">
  <h2 mat-dialog-title><strong> Permisos </strong></h2>
  <div
    style="width: 30px; height: 30px; border-radius: 50%; display: flex; justify-content: center; align-items: center; cursor: pointer;"
    class="mat-elevation-z3" (click)="dialogRef.close()"><i class="fa fa-times "></i></div>
</div>

<mat-dialog-content class="mat-typography">
  <div *ngIf="tipoRedireccion=='nuevo'">

    <mat-horizontal-stepper linear="true">
      <mat-step [stepControl]="firtsForm">
        <ng-template matStepLabel>Selección</ng-template>

        <form [formGroup]="firtsForm">

          <div class="mat-elevation-z3" style="display: flex; justify-content: space-between; margin-bottom: 15px;">
            <h3 style="margin: 10px;"><strong>{{nombreSelecionado}}</strong></h3>
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
              matStepperNext><i class="fa fa-arrow-right"></i></button>
          </div>

          <div style="display: none">
            <mat-form-field>
              <input autocomplete="off" type="text" formControlName='selecion' matInput required>
            </mat-form-field>
          </div>

          <data-table [columns]='columnasUsuarios' [configuration]='configurationUsuarios'
            (selection)='seleccionadosUsuarios($event)' (clickRow)='clickFilaUsuarios($event)'
            [params]="[{ id:'state', value: 1  }]" [url]='urlGetUsuarios'>
          </data-table>

        </form>

      </mat-step>

      <mat-step [stepControl]="FormPermisos">
        <ng-template matStepLabel>Informacion</ng-template>
        <form [formGroup]="FormPermisos" (ngSubmit)="FormPermisos.valid?saveForm(FormPermisos.value):errorMessage()">

          <div class="mat-elevation-z3" style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
              matStepperPrevious><i class="fa fa-arrow-left"></i></button>
            <h3 style="margin: 10px;"><strong>{{nombreSelecionado}}</strong></h3>
            <h3 style="margin: 10px" *ngIf="usuario"><strong>usuario: {{usuario}}</strong> </h3>
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button matStepperNext
              type="submit"><i class="fa fa-arrow-right"></i></button>
          </div>

          <div style='display: flex; width: 100%; '>
            <div style='flex:12'>
              <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport">
                <div class='first-row'>

                  <div class='row-item'>
                    <mat-form-field>
                      <mat-label>Fecha</mat-label>
                      <input matInput [matDatepicker]="fecha" autocomplete="off" matInput formControlName='date'
                        required>
                      <mat-datepicker-toggle matSuffix [for]="fecha">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fecha [touchUi]='movil?true:false'></mat-datepicker>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                  <div class='row-item'>
                    <mat-form-field>
                      <mat-label>Fecha inicio</mat-label>
                      <input matInput [matDatepicker]="fechaInicio" autocomplete="off" matInput
                        formControlName='startDate' (dateChange)="changeDate($event, 'inicio')" required>
                      <mat-datepicker-toggle matSuffix [for]="fechaInicio">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaInicio [touchUi]='movil?true:false'></mat-datepicker>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                  <div class='row-item'>
                    <mat-form-field>
                      <mat-label>Fecha Final</mat-label>
                      <input matInput [matDatepicker]="fechaFinal" autocomplete="off" matInput
                        formControlName='finalDate' (dateChange)="changeDate($event, 'final')" required>
                      <mat-datepicker-toggle matSuffix [for]="fechaFinal">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaFinal [touchUi]='movil?true:false'></mat-datepicker>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                </div>

                <div class='default-row'>


                  <div class='row-item'>
                    <mat-form-field>
                      <input [readonly]='duracion==null' autocomplete="off" type="text" formControlName='duration'
                        matInput placeholder="Duracion" required>
                    </mat-form-field>
                  </div>

                  <div class='row-item'>
                    <!-- Responsable // genered by-->
                    <combos 
                      [configuration]='combosConfigResponsable' 
                      [required]="true" 
                      [filter]="true"                    
                      (changeOptionDataComplete)="ValueResponsable($event)"  
                      [control]="FormPermisos.get('approvedBy')">
                    </combos>
                  </div>

                  <div class='row-item'>
                    <mat-form-field>
                      <mat-label>Remunerado:</mat-label>
                      <mat-select formControlName="remuneration" required>
                        <mat-option value='1'>
                          SI</mat-option>
                        <mat-option value='0'>
                          NO</mat-option>
                      </mat-select>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>


                </div>

                <div class='default-row'>

                  <div class='row-item'>
                    <mat-form-field>
                      <input autocomplete="off" type="text" formControlName='description' matInput #descripcion
                        maxlength="1024" placeholder="Descripción" required>
                      <mat-hint>{{descripcion.value.length}}/1024</mat-hint>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                </div>

              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </form>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Finalizar</ng-template>
        <div class="mat-elevation-z2" style="display: flex; justify-content: space-between; margin-bottom: 30px;">
          <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
            matStepperPrevious><i class="fa fa-arrow-left"></i></button>
          <button class="mat-elevation-z2" mat-mini-fab color="warn" (click)="save()">
            <mat-icon>save</mat-icon>
          </button>
        </div>

        <div style="width: 100%; display: flex; flex-direction: row;">
          <ng-container *ngTemplateOutlet="SummaryInformation"></ng-container>
        </div>

      </mat-step>

    </mat-horizontal-stepper>

  </div>

  <div *ngIf="tipoRedireccion=='visualizar'" style="width: 100%; display: flex; flex-direction: row;">
    <ng-container *ngTemplateOutlet="SummaryInformation"></ng-container>
  </div>

</mat-dialog-content>

<ng-template #SummaryInformation>

  <div style="width: 50%; height: 100%; display: flex; flex-direction: column; text-align: center; align-self: center;">
    <div>
      <img src="{{imageSrc}}" [ngStyle]="sizePicture">
      <h3 style="margin-top: 15px;"><strong>Nombre: </strong> {{nombreSelecionado}}</h3>
      <h3><strong>usuario: </strong> {{usuario}}</h3>
    </div>
  </div>

  <div style="text-align: center; width: 50%; height: 100%;">
    <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z1">
      <mat-tab label="">
        <mat-list>

          <mat-list-item><strong>Fecha</strong>: {{fechaLabel}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Fecha Inicio</strong>: {{inicio}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Fecha Fin</strong>: {{final}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Duración</strong>: {{duracion}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Aprobado Por</strong>: {{aprobadoLabel}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Remunerado</strong>: {{remuneracionLabel}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Descripción</strong>: {{descripcionLabel}} </mat-list-item>
          <mat-divider></mat-divider>

        </mat-list>
      </mat-tab>
    </mat-tab-group>
  </div>

</ng-template>